import React from "react";

import OmGate from "../../assets/Om Gate.jpeg";

let frontendSkills = [
  "JavaScript",
  "TypeScript",
  "React.js",
  "Next.js",
  "Vue.js",
  "Nuxt.js",
  "Tailwind",
  "Styled Components",
];

let backendSkills = [
  "Python",
  "Node.js",
  "Flask",
  "ExpressJS",
  "FastAPI",
  "SocketIO",
  "Websockets",
];

let aiSkills = ["RAG Pipelines", "Agent Orchestration", "MCP", "LangGraph"];

export default function index() {
  return (
    <div className="fade-in flex flex-col gap-8 justify-center items-center text-neutral-50 mt-12 mb-4 w-[90%] md:w-[50%] text-center mx-auto">
      <img
        className="w-32 h-32 rounded-full mx-auto p-1"
        alt="Om Gate"
        src={OmGate}
      />
      <div className="text-neutral-400">
        Hi! I am <span className="text-white">Om Gate</span>, a{" "}
        <span className="text-white">Software Engineer</span> at{" "}
        <a
          className="text-white border-b border-transparent hover:border-white transition-all duration-100"
          href="https://videodb.io"
          target="_blank"
          rel="noreferrer"
        >
          VideoDB
        </a>
      </div>
      <div className="text-neutral-400">
        I'm a full-stack developer skilled in{" "}
        <span className="text-white">React, Next.js, Vue.js </span>
        and <span className="text-white">TypeScript</span>. I architect and
        build <span className="text-white">multi-agent AI systems</span>,
        develop SDKs, and create scalable video AI platforms. I've won
        hackathons for <span className="text-white">BreakFree</span> and{" "}
        <span className="text-white">TrackIt</span>, and I'm a{" "}
        <span className="text-white">speaker at Epic Web Dev</span>. Beyond
        coding, I share my journey through my{" "}
        <a
          className="text-white border-b border-transparent hover:border-white transition-all duration-100"
          href="https://omgate.hashnode.dev/"
          target="_blank"
          rel="noreferrer"
        >
          blog
        </a>
        .
      </div>

      <div className="flex flex-col gap-4 w-[90%]">
        <div className="flex gap-2 text-sm flex-wrap justify-center">
          {frontendSkills.map((skill) => (
            <p
              key={skill}
              className="outline outline-1 outline-purple-900 text-purple-400 py-0.5 px-2 rounded-full"
            >
              {skill}
            </p>
          ))}
        </div>
        <div className="flex gap-2 text-sm flex-wrap justify-center">
          {backendSkills.map((skill) => (
            <p
              key={skill}
              className="outline outline-1 outline-blue-900 text-blue-400 py-0.5 px-2 rounded-full"
            >
              {skill}
            </p>
          ))}
        </div>
        <div className="flex gap-2 text-sm flex-wrap justify-center">
          {aiSkills.map((skill) => (
            <p
              key={skill}
              className="outline outline-1 outline-green-900 text-green-400 py-0.5 px-2 rounded-full"
            >
              {skill}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
}
